import PopperMenu from "@metacrm/metacrm-material-ui/dist/PopperMenu";
import { Box } from "@mui/material";
import axios from "axios";
import { es } from "date-fns/locale";
import { apiUrl } from "features/configure";
import { useConfirm } from "features/home/ConfirmDialogProvider";
import React, { useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useOutletContext } from "react-router";

export default function ActionButton({
  length,
  knowledge,
  refetch,
  refreshBtn = false,
  disabled = false,
}) {
  const [entityName] = useOutletContext();
  const anchorRef = useRef();
  const [actionOpen, setActionOpen] = useState(false);
  const confirm = useConfirm();
  const { formatMessage } = useIntl();
  function openActionMenu() {
    if (disabled) return;
    setActionOpen(true);
  }

  return (
    <Box className="item-flex" justifyContent="center">
      <i
        ref={anchorRef}
        className="meta-crm-icon-ic_dots font-size-20"
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? "#A5A5A5" : "#7B61FF",
        }}
        onClick={openActionMenu}
      />

      <PopperMenu
        itemList={[
          refreshBtn && {
            children: <Box color="#222222">Refresh</Box>,
            func: async (e) => {
              e.stopPropagation();
              await refetch();
            },
          },
          {
            children: <Box color="#FC5555">Delete Knowledge</Box>,
            func: async (e) => {
              e.stopPropagation();
              if (length > 1) {
                confirm({
                  width: "350px",
                  title: formatMessage({
                    id: "knowledgeBase.popup.confirmToDelete.title",
                  }),
                  content: formatMessage({
                    id: "knowledgeBase.popup.confirmToDelete.description",
                  }),
                  confirmText: formatMessage({
                    id: "knowledgeBase.btn.delete",
                  }),
                  cancelText: "Cancel",
                  color: "error",
                  cancelColor: "setting",
                })
                  .then(async () => {
                    await axios.delete(
                      `${apiUrl}/api/knowledgeBase/${entityName}/resources/${knowledge._id}`
                    );
                    await refetch();
                  })
                  .catch(() => {});
              } else {
                confirm({
                  title: formatMessage({
                    id: "knowledgeBase.popup.onlyOneLeft.title",
                  }),
                  content: formatMessage({
                    id: "knowledgeBase.popup.onlyOneLeft.description",
                  }),
                  confirmText: formatMessage({ id: "global.btn.gotIt" }),
                  color: "secondary",
                })
                  .then(() => {})
                  .catch(() => {});
              }
            },
          },
        ].filter(Boolean)}
        open={actionOpen}
        onClose={() => setActionOpen(false)}
        anchorEl={anchorRef.current}
      />
    </Box>
  );
}
